export class CurrentUser {
  accessToken: string;
  role: string;
  userId: string;
  name:string;
  accountId?: string
  isAdminConexia?: boolean
}
